import { takeLatest } from 'redux-saga'
import { put, select, call, all } from 'redux-saga/effects'
import { updateUiAction } from 'actions/uiActions'
import { changeCameraModelSelector } from 'selectors'
import { REMOVE_CAMERA_MODEL, clearModelReferencesAction } from 'actions/cameraActions'
import { updatePresentationValuesAction } from 'actions/presentationActions'
import { clearMultiImagerLensesAction } from 'actions/multiImagerActions'
import findById from 'helpers/findById'

export function* removeCameraConfiguration(action) {
  const { currentCamera: { id, isMultiImager, lensIds, remove }, cameras } = yield select(changeCameraModelSelector)

  // remove lenses before removing model
  if (isMultiImager) {
    // remove multi imager and lenses from map
    yield call(remove)
    yield all(lensIds.map(lensId => call(findById({ state: cameras, id: lensId }).remove)))
    yield put.resolve(clearMultiImagerLensesAction(id, lensIds))
  }

  yield put(updateUiAction({ modal: null }))
  yield put(clearModelReferencesAction(id))
  yield put(updatePresentationValuesAction())
}

export function* watchRemoveCameraConfiguration() {
  yield* takeLatest(REMOVE_CAMERA_MODEL, removeCameraConfiguration)
}



// WEBPACK FOOTER //
// ./src/sagas/removeCameraModelSaga.js